import { render, staticRenderFns } from "./AppDropdownItem.vue?vue&type=template&id=6051f75c&scoped=true&"
import script from "./AppDropdownItem.vue?vue&type=script&lang=js&"
export * from "./AppDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdownItem.vue?vue&type=style&index=0&id=6051f75c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051f75c",
  null
  
)

export default component.exports